import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import { formatImage } from '@ifeng-fe/public_method';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const VideoGags = ({ content, videoGagsImage }) => {
    const swiperRef = useRef();

    return (
        <div className={styles.videoGags}>
            <Chip id="260723" title="视频花絮专区标题图" groupName="中国力量" type="struct">
                <div className={styles.videoGagsTitle}>
                    <img className={styles.videoGagsTitle} src={videoGagsImage} />
                </div>
            </Chip>
            <Chip id="287971" title="视频花絮专区" groupName="中国力量" type="recommend">
                <div className={styles.videoGagsSwiper}>
                    <Swiper
                        modules={[Navigation, Mousewheel, Keyboard]}
                        speed={300}
                        allowTouchMove={false}
                        slidesPerView={1}
                        spaceBetween={0}
                        loop
                        navigation={{ prevEl: `.${styles.prevBox}`, nextEl: `.${styles.nextBox}` }}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}>
                        {content.map((item, index) => {
                            const groupIndex = Math.floor(index / 4);
                            const isFirstInGroup = index % 4 === 0;

                            if (isFirstInGroup) {
                                const group = content.slice(index, index + 4);

                                return (
                                    <SwiperSlide key={groupIndex}>
                                        {group.map((groupItem, groupIndex) => {
                                            const thumbnail = groupItem?.posterUrl || groupItem?.thumbnail || groupItem?.thumbnails?.image?.[0]?.url || '';

                                            return (
                                                <a href={groupItem.url} key={groupIndex} target="_blank" rel="noreferrer" className={styles.videoGagsSwiperSlide}>
                                                    <img className={styles.videoGagsSwiperPic} src={formatImage(thumbnail, 235, 155)} />
                                                    <div className={styles.videoGagsPlayIcon} />
                                                    <div className={styles.videoGagsSwiperTitle}>{groupItem.title}</div>
                                                </a>
                                            );
                                        })}
                                    </SwiperSlide>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </Swiper>
                    <div className={styles.prevBox}>
                        <img className={styles.prev} src="https://x0.ifengimg.com/ucms/2023_37/E72CAF43C3C7064F67581A81080D5D84E0D7BAEC_size5_w30_h80.png" alt="" />
                    </div>
                    <div className={styles.nextBox}>
                        <img className={styles.next} src="https://x0.ifengimg.com/ucms/2023_37/BD80592C08000F5C843AF2B56719151973C59207_size5_w30_h80.png" alt="" />
                    </div>
                </div>
            </Chip>
        </div>
    );
};

VideoGags.propTypes = {
    content: PropTypes.array,
    videoGagsImage: PropTypes.string,
};

export default errorBoundary(VideoGags);
